import { render, staticRenderFns } from "./TenancyAdjustment.vue?vue&type=template&id=3bcdec26&scoped=true"
import script from "./TenancyAdjustment.vue?vue&type=script&lang=js"
export * from "./TenancyAdjustment.vue?vue&type=script&lang=js"
import style0 from "./TenancyAdjustment.vue?vue&type=style&index=0&id=3bcdec26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcdec26",
  null
  
)

export default component.exports